import axios from 'axios';
import { BASE_URL } from '@/config/const';

class PreorderAPI {
  async get (id) {
    return await axios.get(`${BASE_URL}/v2/preorder/${id}`);
  }

  async purchase ({ id, payload }) {
    return await axios.post(`${BASE_URL}/v2/preorder/${id}/buy`, payload, { silent: true });
  }
}

export default new PreorderAPI();


